var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerCertificateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.784,
    height: 47.184,
    viewBox: "0 0 16.277 20.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "upload_file_FILL0_wght200_GRAD0_opsz24",
    d: "M207.325-823.356h1.127v-5.29l2.367,2.367.8-.8-3.727-3.727-3.727,3.727.8.8,2.36-2.36Zm-5.5,3.641a1.763,1.763,0,0,1-1.3-.521,1.763,1.763,0,0,1-.521-1.3V-838.18a1.763,1.763,0,0,1,.521-1.3,1.763,1.763,0,0,1,1.3-.521h8.885l5.071,5.071v13.393a1.763,1.763,0,0,1-.521,1.3,1.763,1.763,0,0,1-1.3.521Zm8.322-14.65v-4.508H201.82a.663.663,0,0,0-.477.217.663.663,0,0,0-.217.477v16.644a.663.663,0,0,0,.217.477.663.663,0,0,0,.477.217h12.136a.663.663,0,0,0,.477-.217.663.663,0,0,0,.217-.477v-12.829Zm-9.015-4.508v0Z",
    transform: "translate(-199.75 840.25)",
    fill: "#1447b2",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerCertificateIcon);
export default __webpack_public_path__ + "static/media/partner_certificate_icon.5ac088f467b9ad04285dd0e9fdf2cc12.svg";
export { ForwardRef as ReactComponent };